import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BlobConvert } from '@utilities/blob-convert';
import { SnackbarService } from '@widgets/site-common/snackbar/snackbar.service';
import { EMPTY, Observable, throwError, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router, private snackbarService: SnackbarService, private matDialog: MatDialog) {}
  // tslint:disable-next-line: no-any
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error(error);
        if (error.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          this.snackbarService.error(error.error.message);
        } else {
          switch (error.status) {
            case 401:
              this.router.navigate(['/']);
              break;
            case 404:
              this.matDialog.closeAll();
              this.router.navigate(['/page-not-found']);
              break;
            case 403:
              this.matDialog.closeAll();
              this.router.navigate(['/access-denied']);
              break;
            case 400:
              if (error.error instanceof Blob) {
                return BlobConvert.blobToText(error.error).pipe(
                  switchMap(t => {
                    this.snackbarService.error(t);
                    return throwError(null);
                  })
                );
              } else {
                this.snackbarService.error(error.message);
              }
              break;
            default: {
              if (error.error instanceof Blob) {
                BlobConvert.blobToText(error.error).subscribe(t => {
                  this.matDialog.closeAll();
                  this.router.navigate(['/internal-server-error'], { state: { message: error.message, details: t } });
                });
              } else {
                this.matDialog.closeAll();
                this.router.navigate(['/internal-server-error'], { state: { message: error.message } });
              }
            }
          }
        }
        return throwError(error);
      })
    );
  }
}
